module.exports = __webpack_public_path__ + "static/media/Elf.b268f0b7.jpg";